import { Input, Select } from "antd"
import React, { useRef } from "react"
import CustomRangePicker from "src/components/CustomRangePickerMobile/CustomRangePicker"
import Button from "src/components/MyButton/Button"
import SvgIcon from "src/components/SvgIcon"
import SelectCountry from "src/components/Dropdown/SelectCountry"
import SelectProvider from "src/components/Dropdown/SelectProvider"
import SelectPackage from "src/components/Dropdown/SelectPackage"
import SelectCustomer from "src/components/Dropdown/SelectCustomer"
import { InputSearchStyle } from "src/pages/ADMIN/HumanResource/styled"

const FilterData = ({ filter, setFilter, setKeyword }) => {
  const inputSearchRef = useRef()
  const onSearch = () => {
    const keyword = inputSearchRef.current || ""
    setKeyword(keyword)
  }
  const onClearSearch = () => {
    inputSearchRef.current = ""
    setKeyword("")
  }

  return (
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: 16,
        minWidth: "100%",
      }}
    >
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: 12,
          maxWidth: "1000px",
        }}
      >
        <SelectCustomer
          style={{ width: 150 }}
          type={"CUSTOMER"}
          placeholder="Khách hàng"
          onChange={val =>
            setFilter(prev => ({ ...prev, customer_id: val }))
          }
          position={9}
        />
        {/* <SelectProvider
          style={{ width: 150 }}
          onChange={val => setFilter(prev => ({ ...prev, supplier_id: val }))}
        /> */}
        {/* <SelectCountry
          type=""
          style={{ width: 150 }}
          onChange={val =>
            setFilter(prev => ({ ...prev, coverage_country_id: val }))
          }
        /> */}
        {/* <SelectPackage
               style={{ width: 150 }}
               onChange={val => setFilter(prev => ({ ...prev, package_id: val }))}
               listAll={true}
             /> */}

        <CustomRangePicker
          style={{ width: 250 }}
          format="DD/MM/YYYY"
          onChange={dates => {
            if (dates) {
              const [start, end] = dates
              setFilter(prev => ({
                ...prev,
                start_date: start ? start.format("YYYY-MM-DD") : undefined,
                end_date: end ? end.format("YYYY-MM-DD") : undefined,
              }))
            } else {
              setFilter(prev => ({
                ...prev,
                start_date: undefined,
                end_date: undefined,
              }))
            }
          }}
        />
      </div>
      <div>
        <InputSearchStyle>
          <Input
            className="custom-input"
            placeholder="Mã đơn hàng"
            allowClear
            onChange={e => (inputSearchRef.current = e.currentTarget.value)}
            onPressEnter={onSearch}
            onClear={onClearSearch}
          />
          <div className="custom-icon-search" onClick={onSearch}>
            <SvgIcon name="searchStatistic" />
          </div>
        </InputSearchStyle>
      </div>
    </div>
  )
}
export default FilterData
